
import HTTP from '@/config/axios-config-erp'

const ServiceEntidadesPostales = {
  getCountries () {
    const payload = {
      orderBy: 'nombrePais',
      order: 'ASC'
    }

    return HTTP.post(`/wscomun/portalinformes/lovPai`, payload).then((response) => {
      return response.data.dataRes
    }).catch((error) => {
      console.log(error)
    })
  },

  getCountryProvinces (country) {
    const payload = {
      pais: country,
      orderBy: 'id',
      order: 'ASC'
    }
    return HTTP.post(`/wscomun/portalinformes/lovEpp`, payload).then((response) => {
      return response.data.dataRes
    }).catch((error) => {
      console.log(error)
    })
  }
}

export default ServiceEntidadesPostales



// WEBPACK FOOTER //
// ./src/services/srv-entidades-postales.js